import { Spinner } from "react-bootstrap";

export const LoadingSpinner = () => {
    return (
        <div
            style={{
                height: "100%",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
            }}
        >
            <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        </div>
    );
};
